var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirTankOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 68,
    viewBox: "0 0 51 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M18.19,45.45a.928.928,0,0,1-.93-.93V30.64a.935.935,0,0,1,.93-.93h1.95a.928.928,0,0,1,.93.93V44.52a.935.935,0,0,1-.93.93Z",
    fill: "#858fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M20.14,30.03a.606.606,0,0,1,.61.61V44.52a.612.612,0,0,1-.61.61H18.19a.606.606,0,0,1-.61-.61V30.64a.612.612,0,0,1,.61-.61h1.95m0-.64H18.19a1.261,1.261,0,0,0-1.26,1.26V44.53a1.261,1.261,0,0,0,1.26,1.26h1.95a1.261,1.261,0,0,0,1.26-1.26V30.64a1.266,1.266,0,0,0-1.26-1.25Z",
    fill: "#404041"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9836",
    "data-name": "Group 9836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9833",
    "data-name": "Group 9833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M19.16,32.6A16.14,16.14,0,1,1,35.35,16.46,16.181,16.181,0,0,1,19.16,32.6Z",
    fill: "#858fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M19.16.65A15.82,15.82,0,1,1,3.3,16.46,15.838,15.838,0,0,1,19.16.65m0-.65A16.46,16.46,0,1,0,35.67,16.46,16.51,16.51,0,0,0,19.16,0Z",
    fill: "#404041"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M7.91,26.68l-.77-1.04,2.92-2.14a11.468,11.468,0,1,1,20.78-6.71,11.32,11.32,0,0,1-2.08,6.57l2.73,2.17-.81,1.01-3.73-2.96.4-.51a10.045,10.045,0,0,0,2.19-6.29,10.18,10.18,0,1,0-18.06,6.43l.43.53Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 1.3,
    height: 4.82,
    transform: "translate(18.71 1.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M29.63,13.03,29.2,11.8l4.13-1.45.44,1.22Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M9.01,12.49,4.9,11.04l.44-1.22,4.1,1.44Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M19.32,19.88a4.05,4.05,0,1,1,4.06-4.05A4.061,4.061,0,0,1,19.32,19.88Zm0-5.51a1.46,1.46,0,1,0,1.47,1.46A1.47,1.47,0,0,0,19.32,14.37Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M16.89,14.78a1.319,1.319,0,0,1-.94-.4L9.6,7.69a1.286,1.286,0,0,1,.05-1.83,1.307,1.307,0,0,1,1.84.05l6.35,6.68a1.3,1.3,0,0,1-.05,1.83A1.323,1.323,0,0,1,16.89,14.78Z",
    fill: "#231f20"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9848",
    "data-name": "Group 9848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M50.68,52.48H47.94c-.24-5.97-1.72-10.57-3.53-10.57H5.84c-1.81,0-3.28,4.61-3.53,10.57H.32v3.41H2.31c.24,5.97,1.72,10.57,3.53,10.57H44.41c1.81,0,3.28-4.61,3.53-10.57h2.74Z",
    fill: "#858fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M44.41,66.79H5.84c-2.3,0-3.59-5.42-3.84-10.57H0V52.16H2c.25-5.15,1.54-10.57,3.84-10.57H44.41c2.3,0,3.59,5.42,3.84,10.57H51v4.06H48.25C48,61.37,46.71,66.79,44.41,66.79ZM.65,55.57H2.63l.01.31c.26,6.34,1.86,10.26,3.2,10.26H44.41c1.34,0,2.94-3.92,3.2-10.26l.01-.31h2.72V52.81H47.62l-.01-.31c-.26-6.34-1.86-10.26-3.2-10.26H5.84c-1.34,0-2.94,3.92-3.2,10.26l-.01.31H.65Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M11.41,67.48H10.14a.4.4,0,0,1-.4-.4V41.3a.4.4,0,0,1,.4-.4h1.27a.4.4,0,0,1,.4.4V67.08A.408.408,0,0,1,11.41,67.48Z",
    fill: "#858fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M11.41,67.8H10.14a.717.717,0,0,1-.72-.72V41.3a.717.717,0,0,1,.72-.72h1.27a.717.717,0,0,1,.72.72V67.08A.717.717,0,0,1,11.41,67.8ZM10.13,41.22a.068.068,0,0,0-.07.07V67.07a.068.068,0,0,0,.07.07H11.4a.068.068,0,0,0,.07-.07V41.3a.068.068,0,0,0-.07-.07H10.13Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M39.83,67.68H38.56a.4.4,0,0,1-.4-.4V41.5a.4.4,0,0,1,.4-.4h1.27a.4.4,0,0,1,.4.4V67.28A.4.4,0,0,1,39.83,67.68Z",
    fill: "#858fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M39.83,68H38.56a.717.717,0,0,1-.72-.72V41.5a.717.717,0,0,1,.72-.72h1.27a.717.717,0,0,1,.72.72V67.28A.717.717,0,0,1,39.83,68ZM38.56,41.42a.068.068,0,0,0-.07.07V67.27a.068.068,0,0,0,.07.07h1.27a.068.068,0,0,0,.07-.07V41.5a.068.068,0,0,0-.07-.07H38.56Z",
    fill: "#404041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirTankOn);
export default __webpack_public_path__ + "static/media/air_tank_on.db41ee700d2f5e7745761cf2444eb5fb.svg";
export { ForwardRef as ReactComponent };